<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'"
    :right="$vuetify.rtl"
    :src="barImage"
    app
    width="300"
    v-bind="$attrs"
    clipped
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="text-uppercase font-weight-regular text-h3">
          <span class="ml-2 mr-6" />
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list
      expand
      nav
    >
      <div />

      <template v-for="(item, i) in items">
        <base-item-group
          v-if="item.children && item.if($store)"
          :key="`group-${i}`"
          :item="item"
        />

        <base-item
          v-if="!item.children && item.if($store)"
          :key="`item-${i}`"
          :item="item"
        />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      items: [
        {
          icon: 'mdi-briefcase-variant',
          title: 'Юридическим лицам',
          to: '/common/products',
          if: (store) => !store.state.user.current_client,
        },
        {
          icon: 'mdi-clipboard-account',
          title: 'Профиль',
          to: '/common/profile',
          if: (store) => true,
        },
        {
          icon: 'mdi-credit-card-clock',
          title: 'Лояльность',
          group: '/common',
          if: (store) => true,
          children: [
            {
              title: 'Счета',
              to: 'accountparticipant/edit/3',
              if: (store) => true,
            },
          ]
        },
        {
          icon: 'mdi-exit-to-app',
          title: 'Выход',
          to: '/logout',
          if: (store) => true,
        },
      ],
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      profile () {
        return {
          avatar: true,
          group: '',
          title: this.$store.state.user.name,
          children: [
            {
              to: 'profile',
              title: 'Профиль',
            },
          ],
        }
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 0px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
